import { render, staticRenderFns } from "./SimilarAccounts.vue?vue&type=template&id=295ec83f&scoped=true&"
import script from "./SimilarAccounts.vue?vue&type=script&lang=js&"
export * from "./SimilarAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SimilarAccounts.vue?vue&type=style&index=0&id=295ec83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ec83f",
  null
  
)

export default component.exports